import { IconDownload } from "@tabler/icons-react";
import { Button } from "@/components/ui";
import { useExportarCambiosCsv } from "../hooks/use-auditoria";

/**
 * Exporta CSV del scope actual. Se deshabilita cuando hay múltiples
 * categorías en el scope pero el usuario no eligió una específica · el
 * backend exige una categoría para el endpoint de CSV.
 */
export function BotonExportCambiosCsv({
  categoria,
  top,
  habilitado,
}: {
  categoria: string | undefined;
  top: number;
  habilitado: boolean;
}) {
  const exportar = useExportarCambiosCsv();
  return (
    <Button
      variant="default"
      size="xs"
      leftSection={<IconDownload size={12} />}
      loading={exportar.isPending}
      disabled={!habilitado}
      onClick={() => exportar.mutate({ categoria, top })}
    >
      Exportar CSV
    </Button>
  );
}
